import { Component } from "react";
import PropTypes from "prop-types";

export default class FocusOnMount extends Component {
  static propTypes = {
    nextTick: PropTypes.bool,
    children: PropTypes.func.isRequired,
  };

  static defaultProps = {
    nextTick: true,
  };

  componentDidMount() {
    const { nextTick } = this.props;

    if (this.elementRef && typeof this.elementRef.focus === "function") {
      if (nextTick) {
        setTimeout(() => {
          this.elementRef.focus();
        });
      } else {
        this.elementRef.focus();
      }
    }
  }

  handleSetRef = (elementRef) => {
    this.elementRef = elementRef;
  };

  render() {
    const { children } = this.props;

    return children({
      innerRef: this.handleSetRef,
    });
  }
}
